"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _uuid = require("uuid");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("./Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const TooltipContainer = _styledComponents.default.div.withConfig({
  displayName: "IconTooltip__TooltipContainer",
  componentId: "design-system__uydbmu-0"
})([".tooltip{box-shadow:0 0 11px rgba(33,33,33,.2);}"]);

const IconTooltip = _ref => {
  let {
    children,
    text,
    iconSize,
    iconType
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["children", "text", "iconSize", "iconType"]);

  const id = (0, _uuid.v4)();
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react.default.createElement(TooltipContainer, {
    className: "info",
    "data-tip": text,
    "data-for": id
  }, !children ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: iconSize,
    type: iconType
  }) : children, /*#__PURE__*/_react.default.createElement(_reactTooltip.default, _extends({
    effect: "solid",
    type: "light",
    className: "tooltip",
    id: id
  }, rest))));
};

IconTooltip.propTypes = {
  children: _propTypes.default.node,
  text: _propTypes.default.string,
  iconSize: _propTypes.default.string,
  iconType: _propTypes.default.string,
  place: _propTypes.default.string,
  multiline: _propTypes.default.bool
};
IconTooltip.defaultProps = {
  children: null,
  text: null,
  iconSize: '16',
  iconType: 'info',
  place: 'bottom',
  multiline: false
};
var _default = IconTooltip;
exports.default = _default;